/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

//
//    "add" (model, collection, options) — when a model is added to a collection.
//    "remove" (model, collection, options) — when a model is removed from a collection.
//    "before:reset" (collection, options) — before the collection's entire contents have been replaced.
//    "reset" (collection, options) — when the collection's entire contents have been replaced.
//    "sort" (collection, options) — when the collection has been re-sorted.
//    "change" (model, options) — when a model's attributes have changed.
//    "change:[attribute]" (model, value, options) — when a specific attribute has been updated.
//    "destroy" (model, collection, options) — when a model is destroyed.
//    "request" (model, xhr, options) — when a model (or collection) has started a request to the server.
//    "sync" (model, resp, options) — when a model (or collection) has been successfully synced with the server.
//    "error" (model, xhr, options) — when a model's save call fails on the server.
//    "invalid" (model, error, options) — when a model's validation fails on the client.
//    "route:[name]" (params) — Fired by the router when a specific route is matched.
//    "route" (router, route, params) — Fired by history (or router) when any route has been matched.
//    "all" — this special event fires for any triggered event, passing the event name as the first argument.


define(["underscore", "backbone", "utils/events"], function(_, Backbone, Events) {

  // List of view options to be merged as properties.
  // var COMPUTED_MODEL_OPTIONS = ['input', 'output', 'inputModel', 'outputModel'];

  /*
    Behaves as a model but computes the output based on the input
   */
  var ComputedModel = function(wiring, options) {
      this.cid = _.uniqueId('c');
      options = options || {};
      this._configure(options);

      this.wiring = wiring;
      this.input = options.input || wiring.input;
      this.output = options.output || wiring.output;
      this.computedInput = options.computedInput || wiring.computedInput;
      this.initialize.apply(this, arguments);
      this.listenToChanges();
  }


  _.extend(ComputedModel.prototype,
          Backbone.Events,
          Events,
  {

      _configure: function(options) {
        //if (this.options) options = _.extend({}, _.result(this, 'options'), options);
        // _.extend(this, _.pick(options, COMPUTED_MODEL_OPTIONS));
        this.options = options;
      },

      initialize : function(options) {
        return this;
      },

      isActivated: function () {
        return this.wiring.isActivated();
      },

      activate: function(options) {
        this.wiring.activate(options);
      },

      deactivate: function(options) {
        this.wiring.deactivate(options);
      },

      stopListeningToChanges: function(options) {
        this.stopProxyingEvent("computing aborted computed compute", this.wiring);
        //this.stopProxyingEvent("change", this.output);
//        this.stopListeningTo(this.output, "change", this._onOutputChangeEvent);
        this.stopProxyingEvent({"change": "changeinput"}, this.input);
        // this.wiring.deactivate(options);
      },

      listenToChanges: function(options) {
        this.proxyEvent("computing aborted computed compute", this.wiring);
        //        this.proxyEvent("change", this.output);
        this.listenTo(this.output, "change", this._onOutputChangeEvent);
        this.proxyEvent({"change": "changeinput"}, this.input);
        // this.wiring.activate(options);
      },

      _onOutputChangeEvent: function(model, options) {
        if (this.output != model) return;
        this.trigger("change", this, options);
      },

      // forward calls
      set: function() {
        return this.input.set.apply(this.input, arguments);
      },

      unset: function() {
        return this.input.unset.apply(this.input, arguments);
      },

      get: function(attr, options) {
        var res = this.output.get.apply(this.output, arguments);
        if (res === undefined && !(options && options.outputOnly))
          return this.computedInput.get.apply(this.computedInput, arguments);
        return res;
      },

      dispose: function() {
        if (this.input && this.input.dispose) this.input.dispose();
        if (this.output && this.output.dispose) this.output.dispose();
        if (this.computedInput && this.computedInput.dispose) this.computedInput.dispose();
        this.stopListeningToChanges();
        this.stopListening();
      },

      destroy: function () {
        this.dispose();
      },

      submodel: function(path, options) {
        if (!this.input.submodel || !this.output.submodel) {
          throw new Error("Submodel functionality required on input and output to perform submodelling.");
        }

        if (_.isObject(path) && !_.isArray(path) && options === undefined) {
          options = path;
        } else {
          options = options || {};
          options.path = path;
        }

        var inputPath = null, outputPath = null;
        if (!this.options.freezeInputPath) {
          inputPath = options.inputPath !== undefined ? options.inputPath : options.path;
        }
        if (!this.options.freezeOutputPath) {
          outputPath = options.outputPath !== undefined ? options.outputPath : options.path;
        }

        var input, output, computedInput;
        try {
          input = inputPath != null ? this.input.submodel(inputPath, options) : this.input;
          output = outputPath != null ? this.output.submodel(outputPath, options) : this.output;
          computedInput = inputPath != null ? this.computedInput.submodel(inputPath, options) : this.computedInput;
        } catch (e) {
          if (input && input.dispose) input.dispose();
          if (output && output.dispose) output.dispose();
          if (computedInput && computedInput.dispose) computedInput.dispose();
          throw e;
        }

        if (input == this.input && output == this.output) return this;
        var modelOptions = _.extend({}, this.options, options);

        modelOptions.input = input;
        modelOptions.output = output;
        modelOptions.computedInput = computedInput;

        return new ComputedModel(this.wiring, modelOptions);
      }

      // how to use collections?

  });
  ComputedModel.extend = Backbone.Model.extend;

  return ComputedModel;

});
